import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

export const PLATFORM_DATA_SOURCE_ENUM = new GenerateEnum({
  PLATFORM: {
    value: '0',
    label: getLabelText({ key: 'remote.admin.platform', text: '平台' })
  },
  SUPERVISION: {
    value: '1',
    label: getLabelText({ key: 'remote.admin.supervision', text: '监管' })
  },
  THIRD_PARTY: {
    value: '2',
    label: getLabelText({ key: 'remote.admin.thirdParty', text: '第三方' })
  }
})

export const MATCH_STATUS_FILTER_ENUM = new GenerateEnum({
  PENDING: {
    value: '0',
    label: getLabelText({ key: 'remote.admin.toBeMatched', text: '待匹配' })
  },
  MATCHING: {
    value: '1',
    label: getLabelText({ key: 'remote.admin.matching', text: '匹配中' })
  },
  PAUSED: {
    value: '2',
    label: getLabelText({ key: 'remote.admin.paused', text: '已暂停' })
  },
  COMPLETED: {
    value: '3',
    label: getLabelText({ key: 'remote.admin.matchingCompleted', text: '匹配完成' })
  },
  IMPORT_FAILED: {
    value: '4',
    label: getLabelText({ key: 'remote.admin.importFailed', text: '导入失败' })
  },
  IMPORTING: {
    value: '5',
    label: getLabelText({ key: 'remote.admin.importing10281', text: '正在导入' })
  }
})

export const AI_ANALYSIS_STATUS_FILTER_ENUM = new GenerateEnum({
  PENDING: {
    value: '0',
    label: getLabelText({ key: 'remote.admin.toBeAnalyzed', text: '待分析' })
  },
  ANALYZING: {
    value: '1',
    label: getLabelText({ key: 'remote.admin.analyzing', text: '分析中' })
  },
  PAUSED: {
    value: '2',
    label: getLabelText({ key: 'remote.admin.paused', text: '已暂停' })
  },
  COMPLETED: {
    value: '3',
    label: getLabelText({ key: 'remote.common.analysisCompleted', text: '分析完成' })
  },
  FAILED: {
    value: '4',
    label: getLabelText({ key: 'remote.common.analysisFailed', text: '分析失败' })
  },
  IMPORTING: {
    value: '5',
    label: getLabelText({ key: 'remote.admin.importing', text: '导入中' })
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/platformDataVerification.js